import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  uploadId: string;
  name: string;
  description?: string;
}
const createVideo = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/video/create', payload);
  return res.data;
};

export const useCreateBrollVideo = () => {
  return useMutation(createVideo, { onSuccess: (data) => data });
};
